import { fetchResolveRegion } from 'APIPackage/KnmModule/services/knmApi';
import { createDistrictSelectOption } from 'CorePackage/CatalogsModule/common/createDistrictSelectOption';
import { IKnmDistrictSelectOption } from 'CorePackage/CatalogsModule/interfaces/IKnmDistrictSelectOption';

const matchDistrictOption = (
  districtId: string | number | null | undefined,
  federalRegionCode: string | null | undefined,
  options?: IKnmDistrictSelectOption[],
): IKnmDistrictSelectOption | undefined => {
  if (!options?.length) {
    return undefined;
  }

  const foundById = options.find(({ id }) =>
    id != null && districtId != null ? id.toString() === districtId.toString() : false,
  );

  if (foundById) {
    return foundById;
  }

  return options.find(({ code }) =>
    code && federalRegionCode ? parseInt(code, 10) === parseInt(federalRegionCode, 10) : false,
  );
};

const findRegionSelectOptionSync = (
  regionCode?: string | null,
  options?: IKnmDistrictSelectOption[],
): IKnmDistrictSelectOption | undefined => {
  if (!regionCode || !options?.length) {
    return undefined;
  }

  const trimmed = regionCode.trim();

  const foundById = options.find(({ id }) => (id != null ? id.toString() === trimmed : false));

  if (foundById) {
    return foundById;
  }

  // Числовой код региона (001 / 1) — без UUID
  if (!/^\d+$/.test(trimmed)) {
    return undefined;
  }

  return options.find(({ code }) => (code ? parseInt(code, 10) === parseInt(trimmed, 10) : false));
};

/**
 * Определение субъекта РФ.
 * Сначала синхронный матч по id/коду из уже загруженного справочника,
 * иначе — бэкенд (`GET /region/resolve`).
 */
export const findRegionSelectOption = async (
  address?: string | null,
  regionCode?: string | null,
  options?: IKnmDistrictSelectOption[],
): Promise<IKnmDistrictSelectOption | undefined> => {
  if (!address && !regionCode) {
    return undefined;
  }

  const syncMatch = findRegionSelectOptionSync(regionCode, options);

  if (syncMatch) {
    return syncMatch;
  }

  try {
    const district = await fetchResolveRegion(address, regionCode);

    if (!district) {
      return undefined;
    }

    return (
      matchDistrictOption(district.id, district.federalRegionCode, options) ?? createDistrictSelectOption(district)
    );
  } catch {
    return undefined;
  }
};
